module.exports = function(posts) {
	'use strict'
	posts.directive('categoryEditDir',categoryEditDir);
	categoryEditDir.$inject=[];
	function categoryEditDir() {
		return {
			template: require('./partial/category-edit.html'),
			controller:'categoryEditController',
			controllerAs:'vmce',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/category-edit/js/directive/categoryEditDirective.js
// module id = 553
// module chunks = 0